import BaseInputNumberField, { type InputFieldProps } from '../../../components/fields/InputNumberField';
import { InputNumberContainer } from './shared';

const InputNumberField = (props: InputFieldProps) => (
    <InputNumberContainer>
        <BaseInputNumberField {...props} />
    </InputNumberContainer>
);

export default InputNumberField;
